import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ConnectedProps, connect } from "react-redux";
import { asyncRoutes as iORoutes } from "us.collection.input-output/routes";
import Common from "us.common";
import { ConfigurationProvider } from "us.common/ConfigurationContext";
import collectionRoutes from "us.collection/routes";
import { UnauthenticatedTemplate } from "@azure/msal-react";
import { AuthenticatedTemplate } from "@azure/msal-react";
import { SignalRProvider } from "us.common/SignalRProvider";
import { RootState } from "us.helper/types";
import { DrawerProvider } from "us.common/context";
import { Loader, LoginRedirect } from "us.common/components";
import { useAuth } from "us.helper/hooks/useAuth";

const { Page404, AppLayout, ConfigProvider } = Common.Components;

const App: React.FC<PropsFromRedux> = ({ currentLanguage }) => {
  const { isAuthenticated, isInitialized } = useAuth();

  if (!isInitialized) {
    return <Loader />;
  }

  if (!isAuthenticated) {
    return (
      <UnauthenticatedTemplate>
        <BrowserRouter
          future={{
            v7_relativeSplatPath: true,
          }}
        >
          <LoginRedirect />
        </BrowserRouter>
      </UnauthenticatedTemplate>
    );
  }

  return (
    <AuthenticatedTemplate>
      <BrowserRouter
        future={{
          v7_relativeSplatPath: true,
        }}
      >
        <ConfigurationProvider>
          <SignalRProvider>
            <DrawerProvider>
              <AppLayout>
                <ConfigProvider locale={currentLanguage as any}>
                  <Routes>
                    {collectionRoutes(5)}
                    {iORoutes}
                    <Route path="*" element={<Page404 />} />
                  </Routes>
                </ConfigProvider>
              </AppLayout>
            </DrawerProvider>
          </SignalRProvider>
        </ConfigurationProvider>
      </BrowserRouter>
    </AuthenticatedTemplate>
  );
};

const mapStateToProps = (state: RootState) => ({
  currentLanguage: state.common.currentLanguage,
});

const connector = connect(mapStateToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(App);
